<template>
  <div style="display: flex; align-items: center; gap: 10px; width: 100%; margin-bottom: 10px;">
    <BackBtn @click="handleClose" />
    <PageTitle hideMarginLeft class="executor-title">
      Проекты
      <img src="/img/icons/shape.svg" style="width: 32px; height: 32px;" alt="close" />
      Детали проекта
      <img src="/img/icons/shape.svg" style="width: 32px; height: 32px;" alt="close" />
      Исполнители проекта
    </PageTitle>
  </div>

  <div class="header">
    <div class="header__card">
      <div>
        ЖК: {{ basicData.resident_name }}
      </div>
      <div>
        Тип проекта: {{ basicData.project_type_name }}
      </div>
      <div>
        Подъезды: {{ basicData.entrances?.join(', ') }}
      </div>
    </div>
    <div class="header__actions">
      <CustomButton class="header__create-btn header__create-btn-delete" @click="this.onDeleteSubmit(selectedRows)"
        v-if="selectedRows.length > 0">
        <span>Удалить выбранные</span>
        <q-icon name="delete" class="header__create-btn-icon header__create-btn-icon-delete" size="16px" />
      </CustomButton>
      <CustomButton class="header__create-btn" @click="this.handleAddClick">
        <span>Добавить исполнителя</span>
        <q-icon name="add" class="header__create-btn-icon header__create-btn-icon-add" size="16px" />
      </CustomButton>
    </div>
  </div>

  <div class="wrapper">
    <div class="performers-table">
      <CustomTable title="Исполнители проекта" :rowsData="this.projectPerformersData" :columns="this.performersColumns"
        :loading="isEntrancesFetching" :small="true" :custom-body="true" :sticky-header="true"
        :on-add-click="this.handleAddClick" :checkbox="true" :checkbox-value="allSelected"
        @all-check-click="onAllCheckClick">
        <template #customBody="props">
          <q-tr>
            <custom-table-cell align="center" vertical-align="center">
              <CustomCheckbox :value="selectedRows.includes(props.row.project_assign_id)"
                @change="(value) => onRowCheckClick(props.row.project_assign_id, value)" />
            </custom-table-cell>
            <custom-table-cell align="left"
              style="display: flex; align-items: center; justify-content: space-between; height: 56px;">
              <span>{{ props.row.employee_fio }}</span>
              <img src="/img/icons/edit.svg" style="width: 15px; height: 15px;" alt="close"
                @click="handleEditPerformerClick(props.row)" />
            </custom-table-cell>
            <custom-table-cell align="left" vertical-align="center">
              {{ props.row.assign_type_name }}
            </custom-table-cell>
            <custom-table-cell align="left" vertical-align="center">
              {{ props.row.contractor_name }}
            </custom-table-cell>
          </q-tr>
        </template>
      </CustomTable>
    </div>

    <div class="entrances-block block">
      <CustomTable title="Подъезды" :rowsData="this.entrancesData" :columns="this.entrancesColumns"
        :loading="isEntrancesFetching" :small="true" :custom-body="true" :sticky-header="true">
        <template #top-right>
          <div class="header-actions">
            <q-btn :disable="!hasAnyChanges()" label="Сохранить" color="primary" @click="this.handleSaveClick"
              class="action-btn" icon="save" size="sm" />
            <q-btn :disable="!hasAnyChanges()" label="Отменить изменения" color="orange" @click="this.resetChanges"
              class="action-btn" icon="loop" size="sm" />
          </div>
        </template>
        <template #customBody="props">
          <q-tr>
            <custom-table-cell align="left" vertical-align="center" style="width: 33%;">
              {{ props.row.project_entrance_id }}
            </custom-table-cell>
            <custom-table-cell align="left" vertical-align="center" style="width: 33%;">
              {{ props.row.entrance }}
            </custom-table-cell>
            <custom-table-cell align="center" vertical-align="center">
              <CustomInput :autoMinWidth="true" :showClearIcon="false" :value="tempEntrancesData[props.row.project_entrance_id] ||
                props.row.block_name
                " :style="`background-color: ${hasAnyChanges(props.row.project_entrance_id)
                  ? '#d0ffc3'
                  : 'unset'
                  }; margin-bottom: 10px;`" @change_input="
                    (value) =>
                      handleInputChange(props.row.project_entrance_id, value)
                  " />
            </custom-table-cell>
          </q-tr>
        </template>
      </CustomTable>

      <div class="duplicate-performers">
        <CustomButton
          class="header__create-btn duplicate-performers__btn"
          @click="handleDuplicateButtonClick"
        >
          <span>Дублировать исполнителей</span>
          <q-icon
            name="content_copy"
            class="header__create-btn-icon header__create-btn-icon-add"
            size="16px"
          />
        </CustomButton>

      </div>
    </div>
  </div>
</template>

<script>
import PageTitle from '@/components/common/PageTitle.vue'
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import BlockItem from "@/components/common/BlockItem";
import CustomIcon from "@/components/common/CustomIcon";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomInput from "@/components/form/CustomInput";
import {
  deleteShellProjectPerfomancer,
  entrancesColumns,
  getEmployeeList,
  getEntrancesBlockInfo,
  getPerformersByProjectId,
  performersColumns,
  updateShellProjectPerfomancer,
  updEntrancesBlockInfo,
  duplicateProjectAssign,
} from "@/views/ProjectsEntry/services";
import { MODAL_NAMES } from "@/constants";
import Clickable from "@/components/common/Clickable";
import CustomButton from "@/components/common/CustomButton.vue";
import { useAppStore } from "@/services/store/app"
import CustomImg from "@/components/common/CustomImg";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import BackBtn from "@/components/common/BackBtn";

export default {
  name: "ProjectsPerformersInfo",

  props: {
    projectData: Object,
    basicData: Object,
  },

  components: {
    BlockItem,
    CustomIcon,
    CustomInput,
    CustomTable,
    CustomTableCell,
    Clickable,
    CustomButton,
    CustomImg,
    CustomCheckbox,
    BackBtn,
    PageTitle
  },

  async mounted() {
    await this.getPerformersByProjectId();
    await this.getEntrancesInfo();
  },

  data() {
    return {
      projData: this.projectData,
      basicData: this.basicData,
      projectData: {
        project_id: this.projectData.project_id || "",
      },
      isPerformersFetching: false,
      performersColumns,
      projectPerformersData: [],
      assign_types: [],
      isEntrancesFetching: false,
      entrancesColumns,
      entrancesData: [],
      tempEntrancesData: {},
      saveLoading: false,
      infoLoading: false,
      employeesList: [],
      allSelected: false,
      selectedRows: [],
      // Дублирование исполнителей
      isDuplicateLoading: false,
    };
  },

  methods: {
    onAllCheckClick(value) {
      this.allSelected = value;
      this.selectedRows = this.projectPerformersData.map((row) => row.project_assign_id);
    },
    onRowCheckClick(project_assign_id, value) {
      this.selectedRows = this.selectedRows.includes(project_assign_id) ? this.selectedRows.filter((id) => id !== project_assign_id) : [...this.selectedRows, project_assign_id];
    },
    async getPerformersByProjectId() {
      this.isPerformersFetching = true;
      const res = await getPerformersByProjectId(this.projectData.project_id);
      if (!res) return;
      this.projectPerformersData = res;
      this.isPerformersFetching = false;
    },

    async getAssignTypes() {
      const res = await getPerformersByProjectId(this.projectData.project_id);
      if (!res) return;
      this.assign_types = res;
    },

    async handleAddClick() {
      const appStore = useAppStore()
      appStore.showModal(MODAL_NAMES.UpdProjectExecutor, {
        onSubmit: (body) => this.onUpdatePerformerSubmit(body),
        title: "Создать исполнителя",
        body: { project_id: this.projectData.project_id },
      })
    },

    async onDeleteSubmit() {
      let ids = [];
      if (this.allSelected) {
        ids = this.projectPerformersData.map((row) => row.project_assign_id);
      } else {
        ids = this.selectedRows;
      }
      this.isPerformersFetching = true;
      const res = await deleteShellProjectPerfomancer({ project_assign_ids: ids });
      if (!res) return;
      this.projectPerformersData = res;
      this.selectedRows = [];
      this.allSelected = false;
      this.isPerformersFetching = false;
    },

    async handleDuplicateButtonClick() {
      const resident_id = this.basicData?.resident_id;
      const project_type_id = this.basicData?.project_type_id;

      if (!resident_id || !project_type_id) {
        this.showErrorSnackbar("Не удалось определить ЖК и тип проекта для подбора проектов");
        return;
      }

      const appStore = useAppStore();
      appStore.showModal(MODAL_NAMES.DuplicateProjectPerformers, {
        title: "Дублировать исполнителей в проект",
        resident_id,
        project_type_id,
        current_project_id: this.projectData.project_id,
        onSubmit: async ({ project_id }) => {
          await this.duplicatePerformers(project_id);
        },
      });
    },

    async duplicatePerformers(targetProjectId) {
      this.isDuplicateLoading = true;
      try {
        const body = {
          source_project_id: this.projectData.project_id,
          new_project_id: targetProjectId,
        };

        await duplicateProjectAssign(body);

        this.showSucceedSnackbar("Исполнители успешно продублированы");
        const appStore = useAppStore();
        appStore.closeModal();
      } catch (e) {
        this.showErrorSnackbar("Произошла ошибка при дублировании исполнителей");
      } finally {
        this.isDuplicateLoading = false;
      }
    },

    async getEntrancesInfo() {
      this.isEntrancesFetching = true;
      const res = await getEntrancesBlockInfo(this.projectData.project_id);
      if (!res) return;
      this.entrancesData = res;
      this.isEntrancesFetching = false;
    },

    handleInputChange(id, value) {
      this.tempEntrancesData = {
        ...this.tempEntrancesData,
        [id]: value,
      };
    },

    resetChanges() {
      this.tempEntrancesData = {};
    },

    hasAnyChanges(project_entrance_id) {
      if (project_entrance_id === undefined || project_entrance_id === null) {
        return Object.keys(this.tempEntrancesData).length > 0;
      }

      const row = this.entrancesData.find(
        (r) => r.project_entrance_id === project_entrance_id
      );
      if (!row) return false;

      const originalBlock = row.block_name;
      return (
        this.tempEntrancesData[project_entrance_id] !== undefined &&
        this.tempEntrancesData[project_entrance_id] !== originalBlock
      );
    },

    async handleSaveClick() {
      if (!this.hasAnyChanges()) {
        this.showSucceedSnackbar("Нет изменений для сохранения");
        return;
      }

      const blocks = this.entrancesData.map((row) => {
        const id = row.project_entrance_id;
        return {
          project_entrance_id: id,
          block_name:
            this.tempEntrancesData[id] !== undefined
              ? this.tempEntrancesData[id]
              : row.block_name,
        };
      });

      const payload = {
        project_id: this.projectData.project_id,
        blocks,
      };

      const res = await updEntrancesBlockInfo(payload);
      this.tempEntrancesData = {};
      if (res) {
        this.entrancesData = res;
        this.showSucceedSnackbar("Изменения успешно сохранены");
      }
    },

    handleEditPerformerClick(row) {
      const appStore = useAppStore()
      appStore.showModal(MODAL_NAMES.UpdProjectExecutor, {
        onSubmit: (body) => this.onUpdatePerformerSubmit(body),
        title: "Изменить исполнителя",
        body: { ...row, project_id: this.projectData.project_id },
      })
    },
    async onUpdatePerformerSubmit(body) {
      const res = await updateShellProjectPerfomancer(body);
      if (!res) return;

      await this.getPerformersByProjectId();

      this.showSucceedSnackbar();
      const appStore = useAppStore()
      appStore.closeModal();
    },
    async getEmployeesList() {
      const res = await getEmployeeList();
      if (res) {
        this.employeesList = res;
      }
    },

    handleClose() {
      this.$emit("change-tab", "projects_overview")
      this.$emit("close");
    },
  },
  setup() {
    const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar();
    return { showSucceedSnackbar, showErrorSnackbar };
  },
};
</script>

<style scoped lang="scss">
.executor-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  gap: 16px;
  margin-bottom: 0;
}

.header {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  justify-content: space-between;
  align-items: end;

  &__filters {
    display: flex;
    gap: 10px;
  }

  &__item {
    width: 200px;
  }

  &__card {
    background-color: #F2F5F8;
    padding: 11px 16px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 22px;
    color: #373D48;
    font-size: 16px;
    line-height: 16px;
    font-weight: 400;
  }

  &__actions {
    display: flex;
    gap: 10px;
  }

  &__create-btn {
    width: auto;
    height: 46px;
    font-weight: 400;
  }

  &__create-btn-delete {
    background-color: #ff5353;
    color: #fff;
  }

  &__create-btn-delete:hover {
    background-color: #ff5353;
    color: #fff;
  }

  &__create-btn-icon-delete {
    color: #ff5353;
  }

  &__create-btn-icon-add {
    color: #0060fe;
  }

  &__create-btn-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #fff;
  }

  :deep(.q-btn__content) {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  @media (max-width: 400px) {
    &__item {
      width: 100%;
    }
  }
}

.wrapper {
  display: flex;
  gap: 25px;
  align-items: flex-start;
}

@media (max-width: 1299px) {
  .wrapper {
    flex-wrap: wrap;
  }
}

.performers-table {
  width: 100%;
}

.project-header {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 30px;
}

.entrances-block {
  width: 450px;
}

.header-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.duplicate-performers {
  margin-top: 12px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.duplicate-performers__btn {
  min-width: 260px;
  :deep(.q-btn__content) {
    gap: 10px;
  }
}
</style>
